import React, { useEffect, useState } from "react";
import { Wordmark } from "@/components/Wordmark";
import { NAV } from "@/constants/testIds";
import { Phone } from "lucide-react";
import { FounderBadge } from "@/components/FounderBadge";

const links = [
  { id: "services", label: "Services", testId: NAV.linkServices },
  { id: "valuation", label: "Valuation", testId: NAV.linkValuation },
  { id: "founder", label: "About", testId: NAV.linkFounder },
  { id: "industries", label: "Industries", testId: NAV.linkIndustries },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#0A1C14]/85 border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          onClick={() => go("top")}
          className="group flex flex-col items-start leading-none"
          data-testid={NAV.logo}
          aria-label="Transformo home"
        >
          <span className="text-white text-xl md:text-2xl">
            <Wordmark />
          </span>
          <span className="hidden sm:block mt-1 text-[10px] tracking-[0.22em] uppercase text-white/45 group-hover:text-brand-accent transition-colors whitespace-nowrap">
            Registered: Bhanunidhi Business Solutions Pvt Ltd
          </span>
        </button>

        <nav className="hidden xl:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              className="text-sm text-white/70 hover:text-white transition-colors font-medium"
              data-testid={l.testId}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <FounderBadge className="hidden md:inline-flex" />
          <button
            onClick={() => go("contact")}
            className="btn-shine inline-flex items-center gap-2 rounded-md bg-brand-primary hover:bg-brand-primaryHover text-white px-4 md:px-5 py-2 md:py-2.5 text-sm font-semibold transition-colors"
            data-testid={NAV.ctaCallback}
          >
            <Phone className="w-4 h-4" />
            <span className="hidden sm:inline">Request Callback</span>
            <span className="sm:hidden">Call Back</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
